/*
  商品ページの追加処理を記述します
*/

// バリエーションピッカーのボタン化
const changeVariantPicker = (_this) => {
  const variantPicker = document.getElementById(_this.dataset.target);
  variantPicker.value = _this.dataset.value;
  variantPicker.dispatchEvent(new Event("change"));

  document
    .querySelectorAll(".c-product-variant-picker__btn")
    .forEach((btn) => {
      btn.classList.remove("is-active");
      btn.setAttribute("aria-pressed", "false");
    });
  const themeOptionSelectors = document.querySelectorAll(
    ".product-variants select.product-form__input"
  );
  if (
    document.querySelectorAll(".c-product-variant-picker__selected-color")
      .length > 0
  ) {
    document
      .querySelectorAll(".c-product-variant-picker__selected-color.is-active")
      .forEach((btn) => {
        btn.classList.remove("is-active");
      });
  }
  themeOptionSelectors.forEach((themeOptionSelector) => {
    const targetButton = document.querySelector(
      `.c-product-variant-picker__btn[data-target="${themeOptionSelector.id}"][data-value="${themeOptionSelector.value}"]`
    );
    targetButton.classList.add("is-active");
    targetButton.setAttribute("aria-pressed", "true");

    const targetText = document.querySelector(
      `.c-product-variant-picker__selected-color[data-value="${themeOptionSelector.value}"]`
    );
    if (targetText) targetText.classList.add("is-active");
  });
};

const setRecommendations = () => {
  /* 購入欄の下の関連アクセサリー / こちらもおすすめ / 対応機種（snippets/product-complementary.liquid）
     1 点だけのときは動かさない。2 点以上は共通スライダー v2-rail.js で、はみ出すときだけ矢印が出る（見出しの右） */
  const blocks = document.querySelectorAll("[data-pdp-comp]");
  if (!blocks.length || !window.V2Rail) return;
  blocks.forEach((block) => {
    if (block.querySelectorAll(".pdp-comp__item").length < 2) return;
    window.V2Rail.create(block, {
      mode: "cards",
      track: block.querySelector("[data-pdp-comp-track]"),
      list: block.querySelector("[data-pdp-comp-list]"),
      slides: ":scope > .pdp-comp__item",
      nav: true,
      dots: false,
      progress: false,
    });
  });
};

const setQuantityChangeHandler = () => {
  try {
    const quantitySelects = document.querySelectorAll(
      "[data-product-add-to-cart-quantity]"
    );

    if (quantitySelects.length === 0) {
      return;
    }

    quantitySelects.forEach((select, index) => {
      try {
        if (!select.id) {
          return;
        }

        select.addEventListener("change", function () {
          try {
            const fullId = this.id.replace("product-quantity-", "");

            let productId, extractedVariantId;
            if (fullId.includes("-")) {
              const parts = fullId.split("-");
              productId = parts[0];
              extractedVariantId = parts[1];
            } else {
              productId = fullId;
              extractedVariantId = null;
            }

            if (!productId || productId === this.id) {
              return;
            }

            const selectedQuantity = parseInt(this.value, 10);

            if (isNaN(selectedQuantity) || selectedQuantity < 1) {
              return;
            }

            const addToCartButton = document.querySelector(
              `#btn-add-to-cart-${fullId}`
            );

            if (!addToCartButton) {
              return;
            }

            const currentHref = addToCartButton.getAttribute("href");

            if (!currentHref || !currentHref.includes("?")) {
              return;
            }

            const urlParams = new URLSearchParams(currentHref.split("?")[1]);
            const variantId = urlParams.get("id");

            if (!variantId) {
              return;
            }

            const variantIdNum = parseInt(variantId, 10);
            if (isNaN(variantIdNum)) {
              return;
            }

            const newHref = `/cart/add?id=${variantId}&quantity=${selectedQuantity}`;
            addToCartButton.setAttribute("href", newHref);
          } catch (error) {}
        });
      } catch (error) {}
    });
  } catch (error) {}
};

const setProductMainSlider = () => {
  let selectElement = document.querySelector(
    '.product-form__variants[name="id"]'
  );

  /* 共通スライダー v2-rail.js があればそれで動かす（Splide の main.sync(thumbnails) の置き換え） */
  const sliderRoot = document.getElementById("product-slider");
  const mainWrap = sliderRoot && sliderRoot.querySelector(".splide-images-main");
  if (window.V2Rail && mainWrap) {
    const thumbsRoot = document.getElementById("product-thumbnails");
    sliderRoot.classList.add("v2-rail");
    if (thumbsRoot) thumbsRoot.classList.add("v2-rail");
    const main = window.V2Rail.create(mainWrap, {
      mode: "slides",
      track: mainWrap.querySelector(".splide__track"),
      list: mainWrap.querySelector(".splide__list"),
      slides: ":scope > .splide__slide",
      nav: true,
      rewind: true,
    });
    const thumbs = thumbsRoot ? Array.from(thumbsRoot.querySelectorAll(".splide__slide")) : [];
    const thumbList = thumbsRoot && thumbsRoot.querySelector(".splide__list");
    const markThumb = (i) => {
      thumbs.forEach((t, k) => {
        t.classList.toggle("is-active", k === i);
        t.setAttribute("aria-current", k === i ? "true" : "false");
      });
      const t = thumbs[i];
      if (t && thumbList && thumbList.scrollHeight > thumbList.clientHeight) {
        const top = t.offsetTop - thumbList.offsetTop;
        if (top < thumbList.scrollTop || top + t.offsetHeight > thumbList.scrollTop + thumbList.clientHeight) {
          thumbList.scrollTo({ top: Math.max(0, top - 8), behavior: "smooth" });
        }
      }
    };
    thumbs.forEach((t, i) => {
      t.setAttribute("role", "button");
      t.setAttribute("tabindex", "0");
      t.setAttribute("aria-label", i + 1 + " 枚目を表示");
      t.addEventListener("click", () => main.go(i));
      t.addEventListener("keydown", (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); main.go(i); } });
    });
    mainWrap.addEventListener("v2rail:change", (e) => markThumb(e.detail.index));
    markThumb(Math.max(0, main.index()));
    if (!selectElement) return;
    const toVariantImage = () => {
      const opt = selectElement.options[selectElement.selectedIndex];
      const id = opt && opt.dataset.variantImg;
      const idx = thumbs.findIndex((t) => t.dataset.variantImg == id);
      if (idx > -1) main.go(idx);
    };
    toVariantImage();
    selectElement.addEventListener("change", toVariantImage);
    return;
  }

  let main = new Splide("#product-slider", {
    type: "slide",
    rewind: true,
    arrows: true,
  });

  let thumbnails = new Splide("#product-thumbnails", {
    perPage: 10,
    updateOnMove: true,
    pagination: false,
    isNavigation: true,
    arrows: false,
    rewind: false,
    snap: true,
    trimSpace: "move",
    focus: "left",
    breakpoints: {
      600: {
        fixedWidth: 55,
        fixedHeight: 55,
      },
    },
  });

  main.sync(thumbnails);
  main.mount();
  thumbnails.mount();

  // 以下のJSは、顧客が異なるバリアントを選択した際の画像切り替えを処理します。
  if (!selectElement) {
    return;
  }

  selectImgChange();

  selectElement.addEventListener("change", selectImgChange);

  function selectImgChange() {
    let selectedOption = selectElement.options[selectElement.selectedIndex];
    let variantImgId = selectedOption.dataset.variantImg;
    let slideList = document.querySelectorAll("#product-thumbnails ul li");

    slideList.forEach((element, index) => {
      if (element.dataset.variantImg == variantImgId) {
        thumbnails.go(index);
      }
    });
  }
};

const setCouponEvent = () => {
  const jsLabelElements = document.querySelectorAll(".js-label");
  if (jsLabelElements.length > 0) {
    jsLabelElements.forEach((element) => {
      element.addEventListener("click", function () {
        this.classList.toggle("is-show");
      });
    });
  }

  // クリップボードにコピー
  const jsCopyElements = document.querySelectorAll(".js-copy");
  jsCopyElements.forEach((element) => {
    element.addEventListener("click", function () {
      const codeElement = this.closest(".toggle-online")?.querySelector(".code");
      if (codeElement) {
        const code = codeElement.textContent;
        navigator.clipboard.writeText(code).then(function () {
          alert("クーポンコードをコピーしました");
        });
      }
    });
  });

  const scrollToHowToElement = document.getElementById("scrollToHowTo");
  if (scrollToHowToElement) {
    scrollToHowToElement.addEventListener("click", function (e) {
      e.preventDefault();
      const expandElement = document.getElementById("Expand");
      if (expandElement) {
        const expandTop =
          expandElement.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: expandTop - 100,
          behavior: "smooth",
        });
      }

      jsLabelElements.forEach((element) => {
        element.classList.toggle("is-show");
      });
    });
  }
};

const replaceAnyGiftLink = () => {
  const anyGiftButton = document.querySelector(".anygift-e-gift-modal__ui");
  if (!anyGiftButton) {
    return;
  }

  document.querySelector(".anygift-about-link").style.display = "flex";
};

const setProductVariantStock = () => {
  const productVariantStock = document.getElementById("product-variant-stock");
  if (!productVariantStock) {
    return;
  }

  const variantSelect = document.querySelector(
    '.product-form__variants[name="id"]'
  );
  if (!variantSelect) {
    return;
  }

  const selectedVariant = variantSelect.options[variantSelect.selectedIndex];
  const currentStock = parseInt(selectedVariant.dataset.inventoryQuantity) || 0;
  const productCollections = window.product?.collections || [];
  const isAvailable = window.product?.available || false;
  let threshold = 200; // デフォルト閾値

  const targetCollections = [
    "powerhouse",
    "mobileprojector",
    "homeprojector",
    "robotcleaner",
  ];
  if (
    productCollections.some((collection) =>
      targetCollections.includes(collection.handle.toLowerCase())
    )
  ) {
    threshold = 100;
  }

  if (currentStock > 0 && isAvailable && currentStock <= threshold) {
    productVariantStock.style.visibility = "visible";
  } else {
    productVariantStock.style.visibility = "hidden";
  }
};

const setProductVariantSku = (event) => {
  const productVariantSku = document.getElementById("product-variant-sku");
  if (!productVariantSku) {
    return;
  }
  const variantSelect = document.querySelector(
    '.product-form__variants[name="id"]'
  );
  if (!variantSelect) {
    return;
  }
  let selectedVariant;
  if (event?.type === "variantChange") {
    const variantId = event.detail?.variant?.id;
    selectedVariant = Array.from(variantSelect.options).find(
      (option) => option.value === String(variantId)
    );
  } else {
    selectedVariant = variantSelect.options[variantSelect.selectedIndex];
  }
  if (!selectedVariant) {
    productVariantSku.innerHTML = "";
    return;
  }

  const variantColor = selectedVariant.dataset.variantColor || "";
  const variantSku = selectedVariant.dataset.variantSku || "";
  if (!variantSku) {
    productVariantSku.innerHTML = "";
    return;
  }
  const variantColorHtml = variantColor
    ? `<span class="product-variant-sku-item-color" style="font-size: 14px;color:#1A1A1A;">${variantColor}</span>`
    : "";

  productVariantSku.innerHTML = `
    <div class="product-variant-sku-item" style="display: flex; align-items: center; gap: 4px;margin-bottom: 20px;">
      <span class="product-variant-sku-item-label" style="font-size: 10px;color:#666666;">製品型番:</span>
      <span class="product-variant-sku-item-value" style="font-size: 14px;color:#1A1A1A;">${variantSku}</span>
      ${variantColorHtml}
    </div>
    `;
};

const setReviewSummaryNotes = () => {
  const summaryHeader = document.querySelector(".mxpr-summary__header");
  const reviewSubmitButton = document.querySelector(".mxpr-summary__write-review");
  if (!summaryHeader || !reviewSubmitButton) {
    return;
  }

  let shownReviewTipsFlg = false;

  reviewSubmitButton.addEventListener("click", () => {
    if(shownReviewTipsFlg === true) {
      return;
    }

    const ul = document.createElement("ul");
    ul.innerHTML = `
      <li>レビューの掲載には1週間程度お時間をいただく場合がございます。レビュー投稿の詳細は<a href="https://www.ankerjapan.com/pages/review" target="_blank">こちら</a>を確認ください。</li>
      <li>レビューを送信することで、<a href="https://www.ankerjapan.com/pages/terms" target="_blank">利用規約</a>に同意するものとみなします。</li>
      <li>ご投稿いただいた内容が不適切と判断された場合、掲載をお断りすることや、掲載されたコメントを削除させていただく場合がございます。</li>
    `;
    ul.classList.add("mxpr-summary__header-tips")
    summaryHeader.after(ul);
    shownReviewTipsFlg = true;
  });
};

document.addEventListener("DOMContentLoaded", function () {
  setProductMainSlider();
  setCouponEvent();
  setRecommendations();
  setQuantityChangeHandler();
  setProductVariantStock();
  setProductVariantSku();
  setReviewSummaryNotes();

  const variantSelect = document.querySelector(
    '.product-form__variants[name="id"]'
  );
  if (variantSelect) {
    variantSelect.addEventListener("change", setProductVariantStock);
    const productSection = variantSelect.closest('[data-section-type="product"]');
    if (productSection) {
      productSection.addEventListener("variantChange", setProductVariantSku);
    }
  }

  setTimeout(() => {
    replaceAnyGiftLink();
  }, 5000);
});


// Adjust Review Layout
